<h3 mat-dialog-content>Zmień dane uczestnika</h3>
<mat-dialog-content class="pb-4" *ngIf="data.userData">
	<p class="alert alert-danger mt-3" *ngIf="data">
		Pamiętaj, że zmieniasz dane klienta. Zostaną one naniesione we wszystkich jego rezerwacjach.
	</p>
	<ng-container *ngIf="data && data.userData">
		<form [formGroup]="participantForm">
			<div class="d-flex flex-row flex-wrap gap-2">
				<mat-form-field appearance="outline">
					<mat-label>Zwrot grzecznościowy</mat-label>
					<mat-select placeholder="Pan" formControlName="sex">
						<mat-option value="M">Pan</mat-option>
						<mat-option value="F">Pani</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Imię</mat-label>
					<input type="text" matInput formControlName="firstName" />
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Nazwisko</mat-label>
					<input type="text" matInput formControlName="lastName" />
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Data urodzenia</mat-label>
					<input
						matInput
						#dateInput
						[matDatepicker]="datepicker"
						(dateChange)="checkUserIsChild(dateInput.value)"
						formControlName="birth"
					/>
					<mat-hint>MM/DD/YYYY</mat-hint>
					<mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
					<mat-datepicker #datepicker>
						<mat-datepicker-actions>
							<button mat-button matDatepickerCancel>Anuluj</button>
							<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
						</mat-datepicker-actions>
					</mat-datepicker>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Numer telefonu</mat-label>
					<input matInput type="text" placeholder="Numer telefonu" formControlName="phone" />
				</mat-form-field>
			</div>
			<mat-checkbox class="me-2" formControlName="regularCustomer">Stały klient</mat-checkbox>
			<mat-checkbox formControlName="isChild">Dziecko</mat-checkbox>
		</form>
	</ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button (click)="closeDialog()">Porzuć</button>
	<button mat-raised-button color="primary" (click)="submit()" class="submitChanges">Zapisz zmiany</button>
</mat-dialog-actions>
